import React from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import CategoryRoundedIcon from '@mui/icons-material/CategoryRounded';
import { DashboardSectionTitle } from './DashboardSectionTitle';
import { formatKilos, formatPercent } from '../../utils/flujoCalculations';

export const VarietySummaryTable = ({ rows }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
        maxHeight: '45vh',
        overflow: 'hidden',
      }}
    >
      <DashboardSectionTitle icon={<CategoryRoundedIcon />} sx={{ p: 2, pb: 1 }}>
        Resumen por variedad
      </DashboardSectionTitle>
      <TableContainer sx={{ overflow: 'auto' }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow sx={{ bgcolor: '#fbfbfc' }}>
              <TableCell>Variedad</TableCell>
              <TableCell>Almacen</TableCell>
              <TableCell align="right">Volcados</TableCell>
              <TableCell align="right">Clasificados</TableCell>
              <TableCell align="right">Industria</TableCell>
              <TableCell align="right">Podrido</TableCell>
              <TableCell align="right">% rendimiento</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => {
              const rendimiento = row.kilosVolcados > 0
                ? (row.kilosClasificados * 100) / row.kilosVolcados
                : 0;

              return (
                <TableRow key={`${row.idVariedad}-${row.idAlmacen}`} hover >
                  <TableCell sx={{ fontWeight: 800 }}>{row.variedad}</TableCell>
                  <TableCell sx={{ py: 2 }}>{row.almacen}</TableCell>
                  <TableCell align="right">{formatKilos(row.kilosVolcados)} kg</TableCell>
                  <TableCell align="right">{formatKilos(row.kilosClasificados)} kg</TableCell>
                  <TableCell align="right">{formatKilos(row.industria)} kg</TableCell>
                  <TableCell align="right">{formatKilos(row.podrido)} kg</TableCell>
                  <TableCell align="right">{formatPercent(rendimiento)} %</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper >
  );
};
